<template>
  <div class="prescription-container">
    <div class="prescription-main">
      <!-- 处方笺通用样式 -->
      <div class="prescription-paper">
        <div class="card">
          <div class="card-header">
            <h3>处方笺</h3>
            <span class="date">处方编号:{{scriptData.number}}</span>
          </div>
          <div class="card-content">
            <div class="baseinfo-item">
              <div class="type">就诊人信息</div>
              <div class="content">
                <div class="patient-info">{{scriptData.pat_username}}<span>|</span>{{scriptData.gender | genderFilter}}<span>|</span>{{scriptData.birthday | ageFilter}}</div>
              </div>
            </div>
            <div class="baseinfo-item">
              <div class="type">就诊科室</div>
              <div class="content">{{scriptData.p_dep_title}} - {{scriptData.dep_title}}</div>
            </div>
            <div class="baseinfo-item">
              <div class="type">主诉</div>
              <div class="content">{{scriptData.self_reported}}</div>
            </div>
            <div class="baseinfo-item">
              <div class="type">诊断</div>
              <div class="content">{{scriptData.diagnose}}</div>
            </div>
          </div>
        </div>
        <div class="card" v-if="scriptData.status != 4 && scriptData.status != 5">
          <div class="card-content">
            <div class="prescription" v-if="scriptData.r_type == 1">
              <h2>{{scriptData.type | scriptTypeFilter}}</h2>
              <h3>R:</h3>
              <div class="prescription-content">{{herbListString}}</div>
            </div>
            <div class="prescription west" v-else>
              <h2>{{scriptData.type | scriptTypeFilter}}</h2>
              <h3>R:</h3>
              <div class="prescription-west-content">
                <div class="west-herb-item" v-for="item in scriptData.content">
                  <div class="herb-info">
                    <div class="herb-name">{{scriptData.type == 3 ? `${item.name}` : `${item.common_name}`}}
                      {{item.specification}}/{{item.unit}}</div>
                    <div class="herb-num">x{{item.num}}</div>
                  </div>
                  <div class="herb-tip"><span>用法用量:</span>共{{item.days}}天，{{item.frequency}}，每次{{item.dosage}}{{item.dosage_unit}}，{{item.usage}}</div>
                  <div class="herb-tip" v-if="item.remark"><span>特殊说明:</span>{{item.remark}}</div>
                </div>
              </div>
            </div>
            <!-- <div class="prescription-item-wrap">
          <div class="prescription-item">
            <div class="type">剂型与药房</div>
            <div class="content">{{scriptData.type | scriptTypeFilter}} - {{scriptData.company_name | companyFilter}}</div>
          </div>
          <div class="prescription-item" v-if="scriptData.type == 1">
            <div class="type">代煎服务</div>
            <div class="content">{{scriptData.is_decoction == 1 ? '有代煎' : '无代煎'}}</div>
          </div>
        </div> -->
            <h4 class="prescription-title top" v-if="scriptData.r_type == 1">用法用量</h4>
            <div class="prescription-item-wrap" v-if="scriptData.r_type == 1" :style="{paddingBottom: scriptData.advice ? '0px' : '32px'}">
              <div class="prescription-item">
                <div class="type">剂量</div>
                <div class="content"><span>{{scriptData.dose}}</span>剂</div>
              </div>
              <div class="prescription-item">
                <div class="type">用量</div>
                <div class="content"><span>{{scriptData.dosage}}</span>剂/天</div>
              </div>
              <div class="prescription-item">
                <div class="type">用法</div>
                <div class="content">{{scriptData.use_type == 1 ? '内服' : '外用'}} <em v-if="scriptData.use_type == 1">每剂分<span>{{scriptData.usage_direction}}次</span>服用</em></div>
              </div>
            </div>
            <template v-if="scriptData.advice">
              <h4 class="prescription-title">注意事项</h4>
              <div class="notice-text">{{scriptData.advice}}</div>
            </template>

          </div>
        </div>
        <div class="card" v-if="scriptData.excess || tabooData.length > 0 ">

          <div class="over-dose-box">
            <template v-if="scriptData.excess || scriptData.unit_excess">
              <div class="over-tips" v-if="scriptData.r_type == 1"><template v-if="scriptData.excess">{{scriptData.excess}}超出药典建议最大剂量，</template><template
                  v-if="tabooData.length > 0">{{tabooData.join('、')}}存在配伍禁忌，</template><span>确认已知晓</span></div>
              <div class="excess-list" v-if="scriptData.r_type == 2">
                <div class="excess-item" v-for="item in excessData">{{item.name}}<span v-if="item.isUnitExcess">超过单日最大剂量</span><span
                    v-if="item.isExcess && item.isUnitExcess">及</span><span v-if="item.isExcess">用量超过{{item.maxDosage}}天</span></div>
                <div class="tips">确认已知晓</div>
              </div>
              <div class="sign-box">
                <div class="type">医生签章</div>
                <div class="signature">
                  <span>{{scriptData.doc_username}}</span>
                  <p>{{scriptData.doc_id}}</p>
                </div>
              </div>
            </template>
            <div class="price-box" :class="{'only-price': !scriptData.excess}">
              <span class="price-total">共计</span>
              <div class="prescription-price">¥ {{normalPrice | int}}<span>{{normalPrice | float}}</span></div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<style lang="less" scoped>
  .script-price-container{
    margin-top: 12px;
    background: #FFF;
    border-radius: 6px;
    padding: 32px 16px;
    .normal-price{
      padding-bottom: 20px;
      .price-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 29px;
        &:last-child{
          margin-bottom: 0;
        }
        .type{
          font-size: 16px;
          line-height: 16px;
          color: @black;
          font-weight: bold;
          span{
            color: @error;
          }
        }
        .price{
          font-size: 16px;
          line-height: 16px;
          color: #666;
          font-weight: bold;
          &.zero{
            color: #999;
          }
          .selector{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .selector-item{
              height: 32px;
              padding: 0 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #E0E6E6;
              background: #F7F7F7;
              color: #999;
              font-size: 14px;
              cursor: pointer;
              border-radius: 4px;
              transition: all .1s;
              &:first-child{
              margin-right: 16px;
              }
              &.selected{
                border-color: @xile;
                background: @xile;
                color: #FFF;
              }
            }
          }
        }
      }
    }
    .total-price{
      border-top: 1px solid #EEE;
      padding-top: 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .type{
        font-size: 20px;
        line-height: 20px;
        color: @black;
        font-weight: bold;
      }
      .price{
        font-size: 24px;
        line-height: 24px;
        color: @xile;
        font-weight: bold;
        span{
          font-size: 18px;
        }
      }
    }
  }
  .prescription-container{
    min-height: 100vh;
    background: #F7F7F7;
    .prescription-main{
      position: relative;
      padding: 0 8px 12px;
      z-index: 10;
      .prescription-paper{

        padding-top: 12px;
        .card{
          border-radius: 6px;
          background: #FFF;
          overflow: hidden;
          &:not(:first-child){
            margin-top: 12px;
          }
          .card-header{
            padding: 20px 12px 16px 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #FAFAFA;
            border-bottom: 1px solid #F3F3F3;
            h3{
              font-size: 20px;
              line-height: 20px;
              color: @black;
              font-weight: bold;
              display: flex;
              align-items: center;
              span{
                margin-left: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #666;
                font-weight: normal;
              }
            }
            .date{
              font-size: 14px;
              line-height: 14px;
              color: #666;
            }
          }
          .card-content{
            padding: 20px 16px 0;
            .baseinfo-item{
              margin-bottom: 32px;
              .type{
                font-size: 15px;
                line-height: 15px;
                color: #666;
              }
              .content{
                margin-top: 8px;
                font-size: 15px;
                line-height: 20px;
                color: @black;
                font-weight: bold;
                .patient-info{
                  vertical-align: middle;
                  span{
                    font-size: 12px;
                    color: #CCC;
                    margin: 0 12px;
                    font-weight: normal;
                  }
                }
              }
            }
            .prescription{
              padding-bottom: 16px;
              border-bottom: 1px solid #F3F3F3;
              &.west{
                border-bottom: 0;
              }
              h2{
                font-size: 15px;
                line-height: 21px;
                margin-bottom: 12px;
                color: #666;
              }
              h3{
                font-size: 18px;
                line-height: 18px;
                font-weight: bold;
                color: @black;
              }
              .prescription-content{
                margin-top: 8px;
                font-size: 15px;
                line-height: 28px;
                font-weight: bold;
                color: @black;
              }
              .prescription-west-content{
                .west-herb-item{
                  font-weight: normal;
                  padding: 17px 0 15px;
                  &:last-child{
                    padding-bottom: 0;
                  }
                  &:first-child{
                    padding-top: 21px;
                  }
                  .herb-info{
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    font-weight: bold;
                    margin-bottom: 8px;
                    .herb-name{
                      font-size: 15px;
                      line-height: 21px;
                      color: @black;
                      max-width: 85%;
                    }
                    .herb-num{
                      font-size: 15px;
                      line-height: 21px;
                      color: #666;
                    }
                  }
                  .herb-tip{
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    font-size: 14px;
                    line-height: 20px;
                    color: #666;
                    margin-bottom: 4px;
                    span{
                      flex-shrink: 0;
                      margin-right: 4px;
                    }
                  }
                  .herb-control{
                    margin-top: 16px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    button{
                      @button-base();
                      @button-border();
                      height: 32px;
                      font-weight: normal;
                      padding: 0 12px;
                      margin-left: 12px;
                      border-color: #E7EDF3;
                      color: #666;
                      border-radius: 3px;
                      font-size: 14px;
                      &.edit-herb{
                        color: @xile;
                      }
                    }
                  }
                }
              }
            }
            .prescription-item-wrap{
              margin-top: 20px;
              .prescription-item{
                margin-bottom: 32px;
                font-size: 15px;
                line-height: 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #666;
                &:last-child{
                  margin-bottom: 0;
                }
                .content{
                  font-size: 15px;
                  font-weight: bold;
                  color: @black;
                  span{
                    color: @xile;
                    margin: 0 5px;
                  }
                }
              }
            }
            .prescription-title{
              margin-top: 32px;
              font-size: 15px;
              line-height: 15px;
              color: #666;
              font-weight: normal;
              &.top{
                margin-top: 20px;
              }
            }
            .notice-text{
              margin-top: 8px;
              font-size: 15px;
              line-height: 20px;
              font-weight: bold;
              color: @black;
              margin-bottom: 32px;
            }
            .original-script{
              padding: 24px 0;
              display: flex;
              justify-content: center;
              align-items: center;
              border-top: 1px solid #F3F3F3;
              .original-script-button{
                @button-base();
                @button-border();
                border-color: #999;
                color: #666;
                font-size: 13px;
                padding: 0 13px;
                height: 36px;
                svg{
                  color: #666;
                  margin-left: 4px;
                }
                &.disabled{
                  opacity: .6;
                }
              }
            }
          }
          .over-dose-box{
            padding: 24px 16px 0;
            .over-tips{
              position: relative;
              font-size: 14px;
              line-height: 20px;
              padding-left: 10px;
              color: @error;
              font-weight: bold;
              span{
                color: #666;
              }
              &::after{
                content: '';
                position: absolute;
                left: 0;
                top: 8px;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: @error;
              }
            }
            .excess-list{
              font-size: 15px;
              line-height: 21px;
              color: @error;
              .excess-item{
                position: relative;
                padding-left: 10px;
                font-weight: bold;
                &::after{
                  content: '';
                  position: absolute;
                  left: 2px;
                  top: 10px;
                  width: 3px;
                  height: 3px;
                  border-radius: 50%;
                  background: @error;
                }
              }
              .tips{
                font-weight: bold;
                font-size: 15px;
                line-height: 21px;
                color: #666;
                margin-top: 8px;
              }
            }
            .sign-box{
              margin-top: 19px;
              margin-bottom: 23px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .type{
                font-size: 15px;
                line-height: 15px;
                color: #666;
                font-weight: bold;
              }
              .signature{
                position: relative;
                padding: 4px 4px 1px 4px;
                border: 1px solid #CA1F24;
                color: #CA1F24;
                text-align: center;
                font-weight: bold;
                font-size: 12px;
                line-height: 12px;
                border-radius: 2px;
                p{
                  margin-top: 3px;
                }
                &::after{
                  content: '';
                  position: absolute;
                  top: 17px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: calc(100% - 8px);
                  height: 1px;
                  background: #CA1F24;
                }
              }
            }
            .price-box{
              margin-top: -8px;
              border-top: 1px solid #EEE;
              padding: 28px 0 36px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              &.only-price{
                border-top: 0;
                margin-top: 0;
                padding-top: 12px;
              }
              .price-total{
                font-size: 20px;
                line-height: 20px;
                font-weight: bold;
                color: @black;
              }
              .prescription-price{
                font-size: 24px;
                line-height: 24px;
                font-weight: bold;
                color: @xile;
                span{
                  font-size: 18px;
                }
              }
            }
          }
        }
      }
      .original-mask{
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
        .dialog-wrapper{
          display: table-cell;
          vertical-align: middle;
          .dialog-container{
            width: 90%;
            margin: 0px auto;
            border-radius: 5px;
            box-shadow: 0 2px 14px 0 rgba(75,119,174,0.25);
            overflow: hidden;
            transition: all .3s ease;
            .original-close{
              display: flex;
              justify-content: flex-end;
              align-items: center;
              margin-bottom: 16px;
              .close{
                width: 28px;
                height: 28px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                background: rgba(255, 255, 255, .2);
                svg{
                  font-size: 22px;
                  color: #FFF;
                  transform: rotate(45deg);
                }
              }
            }
            .script-box{
              max-width: 95%;
              margin: 0 auto;
              img{
                width: 100%;
              }
            }
            .save-tip{
              text-align: center;
              margin-top: 20px;
              color: #FFF;
              font-size: 17px;
              line-height: 24px;
            }
          }
        }
      }
      // 动画
      .dialog-enter {
        opacity: 0;
      }

      .dialog-leave-active {
        opacity: 0;
      }

      .dialog-enter .dialog-container,
      .dialog-leave-active .dialog-container {
        -webkit-transform: translateY(-20px);
        transform: translateY(-20px);
      }

    }
  }

</style>

<script type="text/javascript">
  export default {

    data() {
      return {

        // 运费
        expressPrice: 0,
        // 是否代煎
        selectedDecoction: null,
        // 代煎费用
        decoctionMoeny: 0,
        isIOS: true,
        excessData: [],
        scriptData: {
          type: Object,
          default: {},
        },
        // 查看处方详情的身份，医生显示超量提示，患者显示对应的支付状态
        role: {
          type: Number,
          default: 1,
        },
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      herbListString() {
        let list = [];
        if (this.scriptData.content && this.scriptData.content.length > 0) {
          this.scriptData.content.forEach(item => {
            let string = ''
            if (this.role == 2) {
              string = `${item.name}`;
            } else {
              string = `${item.name} ${item.num}${item.unit} ${item.remark ? '(' + item.remark + ')' : ''}`;
            }

            list.push(string)
          })
          return list.join('、');
        } else {
          return '无处方';
        }
      },
      totalPrice() {
        let deciction = this.selectedDecoction == 1 ? this.decoctionMoeny : 0;
        if (this.scriptData.normalPrice) {
          return this.scriptData.normalPrice + this.expressPrice + deciction;
        } else {
          return 0;
        }
      },
      normalPrice() {
        if (this.scriptData.price) {
          return this.scriptData.price / 100;
        }
      },
      tabooData() {
        let tabooList = [];
        if (this.scriptData.taboo && this.scriptData.taboo.length > 0) {
          this.scriptData.taboo.forEach(item => {
            let tabooString = `${item.name1}与${item.name2}`;
            tabooList.push(tabooString);
          })
        }
        return tabooList;
      },
    },
    created() {

      const UA = navigator.userAgent;
      this.isIOS = !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      this.$root.post('/getPreDetail', {
        id: this.$route.params.id,
        type: this.userInfo.role
      }).then(data => {
        console.log(data)
        this.dataDone = true;
        if (data && data.end_time) {
          let now = new Date().getTime() / 1000;
          this.leftTime = (data.end_time - now) * 1000;
        }
        if (data.address) {
          this.addressData = data.address;
        }
        this.selectedDecoction = data.is_decoction;
        data.normalPrice = data.price / 100 || 0;
        data.normalExpressage = data.expressage / 100 || 0;
        this.expressPrice = data.normalExpressage;
        this.scriptData = data;
        // 获取代煎费
        this.$root.post('/getDecoctionPrice').then(res => {
          // 代煎费=代煎费单剂价格 * 处方剂量
          this.decoctionMoeny = (res.decoction_price * data.dose) / 100;
          // 如果已选择过代煎服务，则减去代煎服务的价格，还原药方原价
          if (this.selectedDecoction == 1) {
            this.scriptData.normalPrice = this.scriptData.normalPrice - this.decoctionMoeny;
          }
          // 如果有已选地址回显，则减去运费还原药方原价
          if (this.scriptData.normalExpressage) {
            this.scriptData.normalPrice = this.scriptData.normalPrice - this.scriptData.normalExpressage;
          }
        })
        console.log(data);
        if (this.scriptData.r_type == 2) {
          this.excessData = [];
          this.scriptData.content.forEach(item => {
            item.isExcess = JSON.parse(item.isExcess);
            item.isUnitExcess = JSON.parse(item.isUnitExcess);
            if (item.isExcess || item.isUnitExcess) {
              this.excessData.push({
                name: this.scriptData.type == 3 ? item.name : item.common_name,
                isExcess: item.isExcess,
                isUnitExcess: item.isUnitExcess,
                maxDosage: item.max_dosage
              })
            }
          })
        }
      })


    },
    methods: {
      viewPdf(url) {
        this.$router.push({
          path: '/pdf-viewer',
          query: {
            url: url
          }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/presResult.vue